export class PrivateAccountModel {
    applicantFirstName: string;
    applicantMiddleName: string;
    applicantLastName: string;
    applicantBirthDate: string;
    applicantBirthCountry?: string;
    applicantBirthCountryId?: number;
    applicantNationality: number;
    applicantPassportId: string;
    passportAttachmentItems: AttachmentItem[];
    passportSelfieAttachmentItems: AttachmentItem[];
    applicantDateIssue: string;
    applicantDateExpiry: string;
    applicantPlaceOfIssue: string;
    applicantPlaceOfIssueId: number;
    applicantSecondNationality?: number;
    applicantAddress: Address;
    addressAttachmentItems: AttachmentItem[];
    postalAddress?: Address;
    applicantPhone?: string;
    applicantFacebook?: string;
    applicantLinkedin?: string;
    applicantOtherSocialMedia?: string;
    applicantEmail: string;
    cryptocurrencies: boolean;
    employmentPresentOccupation: number;
    employmentPresentOccupationCustom?: string;
    employmentEmployerName: string;
    employmentBusinessSector: string;
    businessCategories: number[];
    employmentYearsInEmployment: number;
    employmentAddress: Address;
    employmentProhibitedActivity: boolean;
    positionInAnyCountry: boolean;
    familyPositionInAnyCountry: boolean;
    litigation?: boolean;
    masterAccountCurrency: number;
    additionalCurrencies: number[];
    averageMonthlyIncome: number;
    averageIncomingTransferAmount: number;
    plannedIncomingTurnoverAmount: number;
    monthlyIncomingTransfersCount: number;
    averageOutgoingTransferAmount: number;
    plannedOutgoingTurnoverAmount: number;
    monthlyOutgoingTransfersCount: number;
    primaryIncomeSource: number;
    primaryIncomeSourceOther: string;
    jurisdiction: number;
    accountName: string;
    countriesTo: number[];
    countriesFrom: number[];
    purposeOfAccountId: number;
    purposeOfAccount?: string;
    introducerName: string;
    introducerEmail: string;
    acceptTerms: boolean;
    acceptPersonalDataUsing: boolean;
    informedAboutServiceProvider: boolean;
    acceptServiceProviderTermsAndConditions: boolean;
    acceptServiceProviderPrivacyPolicy: boolean;
    accSubscribe: boolean;
    usaCitizen?: boolean;
    recaptcha: string;
    products: string[];
    reasons: string[];
    reasonsCustom?: string;
    informationSources: string[];
    informationSourceCustom?: string;
    taxCountry: number;
    taxIdentificationNumber: string;
    neoCheckUserToken: string;
    proofOfAddress: boolean;
}

export interface AttachmentItem {
    id: string,
    name: string,
    attachmentTypeId: number
}

interface Address {
    address: string;
    city: string;
    countryId: number;
    countyOrRegion?: string;
    zipCode: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/entity/private-account.model.ts